import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  addItemToCart,
  getCartItems,
} from "../actions/cartActions"; // replace with your actual cart actions

const CartSync = () => {
  const dispatch = useDispatch();


  const userLogin = useSelector((state) => state.userLogin);
  const { userInfo } = userLogin;

  const cart = useSelector((state) => state.cart);
  const { cartItems } = cart;

  // Fetch server-side cart when logged in
  useEffect(() => {
    if (userInfo) {
      dispatch(getCartItems());
    }
  }, [dispatch, userInfo]);

  // Sync localStorage cart to server after login
  useEffect(() => {
    if (userInfo && cartItems) {
      const savedCart = JSON.parse(localStorage.getItem("savedCart"));

      if (savedCart && savedCart.length > 0) {
        savedCart.forEach((item) => {
          const exists = cartItems.some((c) => c._id === item._id);

          if (!exists) {
            dispatch(addItemToCart(item)); // pass qty if needed
          }
        });

        localStorage.removeItem("savedCart");

        // Optional: Trigger custom event if needed elsewhere
        window.dispatchEvent(new Event("localCartUpdated"));
      }
    }
  }, [userInfo, dispatch, cartItems]);

  return null;
};

export default CartSync;
